import { ValidationSchema, validators } from 'views/declarations/uk/export/validations/validations';
import {
    activeBorderTransportMeans,
    additionalInformation,
    additionalSupplyChainActor,
    binaryIndicator,
    countriesOfRouting,
    customsOfficeOfFirstEntry,
    dateTime,
    goodsItemChildValidators,
    party,
    passiveBorderTransportMeans,
    place,
    referenceNumberUCR,
    representative,
    requiredLevel,
    requiredTransportDocument,
    supportingDocuments,
    transportCharges,
    transportEquipment,
} from './ics2EnsCommonValidation';

export const ics2EnsF11ValidationItem: ValidationSchema = {
    childValidators: goodsItemChildValidators,
};

export const ics2EnsF11ValidationHouseConsignment: ValidationSchema = {
    childValidators: {
        containerIndicator: binaryIndicator(),
        totalGrossMass: [validators.required(), validators.float(16, 6)],
        referenceNumberUCR,
        consignor: party({ required: true }),
        consignee: party(),
        notifyParty: party({ singleCommunication: true }),
        // Both parties are mandatory once the goods shipment is there, so neither is looked at until
        // one of them has been started on - `stopAtEmpty` because an untouched pair is an object of
        // nulls rather than nothing at all. Whether the class is needed in the first place is C3020.
        goodsShipment: {
            childValidators: {
                buyer: party({ required: true }),
                seller: party({ required: true }),
            },
            stopAtEmpty: true,
        },
        placeOfAcceptance: place({ required: true }),
        placeOfDelivery: place({ required: true }),
        transportCharges: transportCharges({ required: true }),
        transportDocumentHouseLevel: requiredTransportDocument,
        passiveBorderTransportMeans: passiveBorderTransportMeans({ nationalityRequired: false }),
        countriesOfRoutingOfConsignment: countriesOfRouting(),
        transportEquipment,
        supportingDocuments,
        additionalInformation,
        additionalSupplyChainActor,
    },
};

export const ics2EnsF11ValidationHeader: ValidationSchema = {
    childValidators: {
        lrn: [validators.maxLength(22)],
        specificCircumstanceIndicator: [validators.required(), validators.exact(3)],
        reEntryIndicator: binaryIndicator(),
        documentIssueDate: dateTime(),
        splitConsignment: {
            childValidators: {
                splitConsignmentIndicator: binaryIndicator(),
                previousMRN: [validators.exact(18)],
            },
        },
        customsOfficeOfFirstEntry,
        declarant: party({ required: true, eoriRequired: true, communicationRequired: true }),
        representative,
        activeBorderTransportMeans: activeBorderTransportMeans(),
        consignmentMasterLevel: {
            childValidators: {
                containerIndicator: binaryIndicator(),
                totalGrossMass: [validators.required(), validators.float(16, 6)],
                referenceNumberUCR,
                consignor: party({ required: true }),
                consignee: party({ required: true }),
                carrier: party({ required: true, eoriRequired: true }),
                notifyParty: party({ singleCommunication: true }),
                placeOfAcceptance: place({ required: true }),
                placeOfLoading: place({ required: true }),
                placeOfUnloading: place({ required: true }),
                placeOfDelivery: place({ required: true }),
                transportCharges: transportCharges({ required: true }),
                transportDocumentMasterLevel: requiredTransportDocument,
                transportEquipment,
                supportingDocuments,
                additionalInformation,
                additionalSupplyChainActor,
                goodsItem: requiredLevel(ics2EnsF11ValidationItem),
                consignmentHouseLevel: requiredLevel({
                    ...ics2EnsF11ValidationHouseConsignment,
                    childValidators: {
                        ...ics2EnsF11ValidationHouseConsignment.childValidators,
                        goodsItem: requiredLevel(ics2EnsF11ValidationItem),
                    },
                }),
            },
        },
    },
};
